@for(item of _tagInput?.tags; track item; let i = $index) {
@if(item?.visible){<div [class]="['eod-tag', 'eod-tag--'+_tagInput?.size, _tagInput?.tagColor]">
    <span [class]="['tag-text']">{{ item?.label }}</span>
    <button [attr.type]="_tagInput?.type" 
      [class]="['tag-action']" (click)="removeTag(i)">
      @if(isIcon){<img [src]="_tagInput?.icon" alt="">}</button>
</div>}
}